import {
  RequestableState,
  handleDone,
  handleFailed,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

type State = { [businessId: number]: RequestableState<dashboard.DashboardPreferences> };

const initialState: State = {};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, context } = action;

  switch (type) {
    case AppConstants.DASHBOARD_PREFERENCES_FETCH_STARTING:
    case AppConstants.DASHBOARD_PREFERENCES_SAVE_STARTING: {
      return {
        ...state,
        [context.businessId]: handleStarting(state[context.businessId], action),
      };
    }

    case AppConstants.DASHBOARD_PREFERENCES_FETCH_DONE:
    case AppConstants.DASHBOARD_PREFERENCES_SAVE_DONE: {
      return {
        ...state,
        [context.businessId]: handleDone(state[context.businessId], action),
      };
    }

    case AppConstants.DASHBOARD_PREFERENCES_FETCH_FAILED:
    case AppConstants.DASHBOARD_PREFERENCES_SAVE_FAILED: {
      return {
        ...state,
        [context.businessId]: handleFailed(state[context.businessId], action),
      };
    }

    default:
      return state;
  }
}
